var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductlistRegist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-plus-circle-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.492 13H12.992V16.5C12.992 16.7652 12.8866 17.0196 12.6991 17.2071C12.5116 17.3946 12.2572 17.5 11.992 17.5C11.7268 17.5 11.4724 17.3946 11.2849 17.2071C11.0974 17.0196 10.992 16.7652 10.992 16.5V13H7.492C7.22678 13 6.97243 12.8946 6.78489 12.7071C6.59736 12.5196 6.492 12.2652 6.492 12C6.492 11.7348 6.59736 11.4804 6.78489 11.2929C6.97243 11.1054 7.22678 11 7.492 11H10.992V7.5C10.992 7.23478 11.0974 6.98043 11.2849 6.79289C11.4724 6.60536 11.7268 6.5 11.992 6.5C12.2572 6.5 12.5116 6.60536 12.6991 6.79289C12.8866 6.98043 12.992 7.23478 12.992 7.5V11H16.492C16.7572 11 17.0116 11.1054 17.1991 11.2929C17.3866 11.4804 17.492 11.7348 17.492 12C17.492 12.2652 17.3866 12.5196 17.1991 12.7071C17.0116 12.8946 16.7572 13 16.492 13ZM12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1Z",
    fill: "#414B56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductlistRegist);
export default __webpack_public_path__ + "static/media/icon_productlist_regist.e1a945d3b399839d61fc38626a43b23f.svg";
export { ForwardRef as ReactComponent };